import React from 'react';
import { Box, LinearProgress, Tooltip } from '@mui/material';
import { Task, TaskStatus } from '../../types/Task';
import { getTaskProgress, taskBaseColor } from '../../utility/task';

type Props = {
  task: Task;
};

const BAR_HEIGHT = 6;

const baseBarSx = {
  position: 'absolute',
  inset: 0,
  height: BAR_HEIGHT,
  borderRadius: 3,
};
export default function TaskProgress({ task }: Props) {
  const { completed, inProgress, total, completedPct, inProgressPct } = getTaskProgress(task);

  const tooltipText = (
    <>
      <div>Completed: {completed}</div>
      <div>In Progress: {inProgress}</div>
      <div>Total Steps: {total}</div>
    </>
  );

  return (
    <Tooltip title={tooltipText} arrow>
      <Box sx={{ position: 'relative', height: BAR_HEIGHT }}>
        {/* In Progress Layer and not started layer */}
        <LinearProgress
          variant="determinate"
          value={inProgressPct}
          sx={{
            ...baseBarSx,
            backgroundColor: taskBaseColor(TaskStatus.NOT_STARTED),
            '& .MuiLinearProgress-bar': {
              backgroundColor: taskBaseColor(TaskStatus.IN_PROGRESS),
            },
          }}
        />

        {/* Completed Layer */}
        <LinearProgress
          variant="determinate"
          value={completedPct}
          sx={{
            ...baseBarSx,
            backgroundColor: 'transparent',
            '& .MuiLinearProgress-bar': {
              backgroundColor: taskBaseColor(TaskStatus.COMPLETED),
            },
          }}
        />
      </Box>
    </Tooltip>
  );
}
